import {SendSupportEmail} from "../Types";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";

export async function send(sendEmail: SendSupportEmail) {
  return await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/support_emails/send`, sendEmail);
}
